import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ConfirmCookiesComponent } from './basic/confirm-cookies/confirm-cookies.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NativeLayerService } from './services/native-layer.service';
import { StorageService } from './services/storage-service.service';
import { UserStorageService } from './services/user-storage-service.service';
import { CookiesConsentService } from './services/cookies-consent.service';
import { AutoUnsubscribeComponent } from './abstracts/auto-unsubscribe.component';
import { SessionStore } from './stores/session.store';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, AfterViewInit {
  title = 'ildes';

  constructor(
    private snackBar: MatSnackBar,
    private native: NativeLayerService,
    private storageService: StorageService,
    private userStorageService: UserStorageService,
    private cookies: CookiesConsentService,
  ) {
  }
    
    ngAfterViewInit(): void {
        sessionStorage.removeItem('clickInPolicy')
        setTimeout(() => {
            if (this.cookies.showCookiesDialog()) {
                this.snackBar.openFromComponent(ConfirmCookiesComponent, {
                    horizontalPosition: 'left',
                    verticalPosition: 'bottom',
                    // panelClass: ['custom-snackbar'] // opcional para estilos
                })
            }
        });
    }

  async ngOnInit() {
    localStorage.setItem('requestMaintenances', 'true')
  }
}
